import { countNewNotifications, getNotifications } from '@/services/api/notification';
import { useQuery } from '@tanstack/react-query';

export const useNotifications = (params?: { page?: number; pageSize?: number }) => {
  const page = params?.page || 1;
  const pageSize = params?.pageSize || 10;

  return useQuery({
    queryKey: ['notifications', page, pageSize],
    staleTime: 0,
    queryFn: () =>
      getNotifications({
        page: Number(page),
        pageSize: Number(pageSize),
      }),
  });
};

export const useCountNewNotifications = () => {
  return useQuery({
    queryKey: ['count-new-notifications'],
    queryFn: () => countNewNotifications(),
    refetchInterval: 10000,
  });
};
